export function HealthyWeekCard({ closeHealthyWeekModel }) {
  return (
    <>
      <div
        className="fixed inset-0 bg-lightblack opacity-50 transition-opacity cursor-pointer"
        id="modal-title"
      ></div>

      <div
        className="fixed inset-0 z-10 overflow-y-auto cursor-pointer "
        onClick={closeHealthyWeekModel}
      >
        <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0 ">
          <div
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl sm:my-8 sm:w-full sm:max-w-lg"
            onClick={(e) => {
              // do not close modal if anything inside modal content is clicked
              e.stopPropagation();
            }}
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4  h-full w-full">
              <div className="text-base font-bold leading-6 text-lightblack">
                Healthy Weeks Discount
              </div>
              <div className="mt-2">
                <p className="text-sm text-lightblack">
                  <span className="text-base leading-5 font-normals">
                    Number of Healthy Weeks accumulated <br />
                    <br />
                    (First 11 month of policy anniversary or risk commencement
                    date)
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
